import { Box, CheckBox, ColorOptions, Icon, Loader, Spacer, TextNew as Text } from '@jfs/ui-new'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { ScrollView, TextInput as RNTextInput } from 'react-native'
import { CardVendors } from '../../../utils'
import { THEME_PADDING } from '../../../utils/constants'
import { CardHolderNameInput } from '../CardHolderNameInput'
import { CardNumberInput } from '../CardNumberInput'
import { CVVToolTip } from '../CVVToolTip'
import { ExpiryCVVInput } from '../ExpiryCVVInput'
import { styles } from './styles'
interface CardDetails {
  cardNumber: string
  cardHolderName: string
  expiry: string
  cvv: string
  isSaveCard?: boolean
  token?: string
  scheme?: number
  type?: number
  isNewCard?: boolean
}

interface CardComponentProps {
  onPayment: (values: CardDetails) => void
  onCardNumberBlur?: (cardVendor: CardVendors, cardNumber: string) => void
  isValid?: boolean
  errMsg?: string
  amount?: string
  hide?: Boolean
  onCardNumberChange?: (cardNumber: string) => void
  onSaveCardVisible?: (isSaveCardVisilbe: boolean) => void
  setCurCardVendor?: (cardVendor: string) => void
  onCardNumberValid?: (isValid: boolean) => void
  theme?: any
  fotterComp?: React.ReactNode
  addlFotterComp?: React.ReactNode
  headerComp?: React.ReactNode
  btnFooter?: React.ReactNode
  btnTitle?: string
  isEMI?: boolean
  isEMIEligible?: boolean
  isLoading?: boolean
  errorColor?: ColorOptions
  isPayButtonEnable?: boolean
  showSCCheckBox?: boolean
  cardNumFooter?: React.ReactNode
  isSubscriptionEnabled?: boolean
}

const CardComponent = ({
  onPayment,
  onCardNumberBlur,
  isValid = true,
  errMsg = '',
  amount,
  hide,
  onCardNumberChange = () => {},
  theme,
  fotterComp,
  addlFotterComp,
  btnTitle,
  isEMI,
  isEMIEligible,
  isLoading,
  errorColor,
  isPayButtonEnable,
  onSaveCardVisible,
  setCurCardVendor,
  headerComp,
  btnFooter,
  cardNumFooter,
  onCardNumberValid,
  showSCCheckBox,
  isSubscriptionEnabled,
}: CardComponentProps) => {
  const [cardHolderName, setCardHolderName] = useState('')

  const [toolTipVisibility, setToolTipVisibility] = useState(false)

  const [cardNumber, setCardNumber] = useState('')
  const [expiry, setExpiry] = useState('')
  const [cvv, setCvv] = useState('')
  const [isSaveCardVisible, setIsSavedCardVisible] = useState(false)

  const [maxCvvLength, setMaxCvvLength] = useState(3)
  // Are all fields valid
  const [isValidCardNumber, setValidCardNumber] = useState(false)
  const [isValidExpiry, setValidExpiry] = useState(false)
  const [isValidCVV, setValidCVV] = useState(false)
  const [isValidCardHolder, setValidCardHolder] = useState(false)
  const [buttonEnabled, setButtonEnabled] = useState(false)

  const [isSaveCard, setSaveCard] = useState(false)
  // Refs of TextInputs
  const cardInputRef = useRef<RNTextInput>(null)
  const expiryInputRef = useRef<RNTextInput>(null)
  const cvvInputRef = useRef<RNTextInput>(null)
  const cardHolderInputRef = useRef<RNTextInput>(null)

  const setCardNumb = (cardNo: string) => {
    setCardNumber(cardNo)
    onCardNumberChange && onCardNumberChange(cardNo)
  }

  useEffect(() => {
    if (isValid && isValidCardNumber && isValidExpiry && cvv.length === maxCvvLength && isValidCardHolder && (!isSubscriptionEnabled || isSaveCard)) {
      !buttonEnabled && setButtonEnabled(true)
    } else {
      buttonEnabled && setButtonEnabled(false)
    }
  }, [
    isValidCardNumber,
    isValidExpiry,
    isValidCVV,
    isValidCardHolder,
    cardNumber,
    buttonEnabled,
    cvv.length,
    maxCvvLength,
    isValid,
    errMsg,
    isSaveCard,
  ])

  if (hide) {
    return null
  }

  const makePayment = () => {
    try {
      onPayment({
        cardNumber: cardNumber.replace(/[^0-9]/g, ''),
        cardHolderName,
        expiry: expiry.replace(' / ', '/'),
        cvv,
        isSaveCard: isSaveCard || isSubscriptionEnabled,
        isNewCard: true,
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
   * Enabling the pay button if it not emi and buttonEnabled(All the validataions completed)
   */
  const enalblePayButton = () => {
    if (!isEMI) {
      return buttonEnabled
    } else if (isEMIEligible) {
      return isPayButtonEnable && buttonEnabled
    } else {
      return buttonEnabled
    }
  }

  const isCardNumberValid = (value: boolean) => {
    setValidCardNumber(value)
    onCardNumberValid && onCardNumberValid(value)
  }

  const style = styles(theme, THEME_PADDING)
  return (
    <Box>
      <ScrollView style={style.scrollStyle} testID={'addCard'}>
        <>
          {headerComp && headerComp}
          <Box {...style.bsContainerMobileTop}>
            <Box {...style.creditCardContainer}>
              <CardNumberInput
                innerRef={cardInputRef}
                nextRef={expiryInputRef}
                errMsg={errMsg}
                onCardNumberBlur={onCardNumberBlur}
                isValidCardNumber={isCardNumberValid}
                isValid={isValid}
                setMaxCvvLength={setMaxCvvLength}
                cardNumber={cardNumber}
                setCardNumber={setCardNumb}
                theme={theme}
                onSaveCardVisible={(isVisible: boolean) => {
                  onSaveCardVisible && onSaveCardVisible(isVisible)
                  setIsSavedCardVisible(isVisible)
                }}
                setCurCardVendor={(cardVendor: string) => setCurCardVendor && setCurCardVendor(cardVendor)}
                errorColor={errorColor}
                cardNumFooter={cardNumFooter}
              />
              <ExpiryCVVInput
                innerRef1={expiryInputRef}
                innerRef2={cvvInputRef}
                prevRef={cardInputRef}
                nextRef={cardHolderInputRef}
                maxCvvLength={maxCvvLength}
                validCvv={cvv.length === maxCvvLength}
                isValidExpiry={(value: boolean) => setValidExpiry(value)}
                isValidCVV={(value: boolean) => setValidCVV(value)}
                expiry={expiry}
                setExpiry={setExpiry}
                fotterComp={fotterComp}
                cvv={cvv}
                setCvv={setCvv}
                theme={theme}
              />
              <CardHolderNameInput
                innerRef={cardHolderInputRef}
                prevRef={cvvInputRef}
                isValidCardHolder={(value: boolean) => setValidCardHolder(value)}
                cardHolderName={cardHolderName}
                setCardHolderName={setCardHolderName}
                addlFotterComp={addlFotterComp}
                theme={theme}
              />
            </Box>
            {isSubscriptionEnabled && (
              <Box>
                <Box pv={'SMALL'} direction={'row'} align={'center'}>
                  <CheckBox
                    onChange={() => setSaveCard(!isSaveCard)}
                    checked={isSaveCard}
                    color={theme?.brandColor as ColorOptions}
                  />
                  <Spacer direction={'horizontal'} size={'SMALL'} />
                  <Text color={theme?.bodyTextColor as ColorOptions} type={'bodySecondary14'}>
                    {'Card will be saved securely'}
                  </Text>
                  <Spacer direction={'horizontal'} size={'SMALL'} />
                  <Box
                    underlayColor={'TRANSPARENT'}
                    onPress={() => setToolTipVisibility(true)}
                    onHover={(value: boolean) => {
                      setToolTipVisibility(value)
                    }}>
                    <Icon id={'INFO'} color={theme?.brandColor as ColorOptions} size={'LARGE'} />
                  </Box>
                </Box>
                <CVVToolTip visible={toolTipVisibility} isSubscriptionEnabled />
              </Box>
            )}

            {showSCCheckBox && isSaveCardVisible && !isSubscriptionEnabled && (
              <Box>
                <Box pv={'SMALL'} direction={'row'} align={'center'}>
                  <CheckBox
                    onChange={() => setSaveCard(!isSaveCard)}
                    checked={isSaveCard}
                    color={theme?.brandColor as ColorOptions}
                  />
                  <Spacer direction={'horizontal'} size={'SMALL'} />
                  <Text color={theme?.bodyTextColor as ColorOptions} type={'bodySecondary14'}>
                    {'Securely save card details'}
                  </Text>
                  <Spacer direction={'horizontal'} size={'SMALL'} />
                  <Box
                    underlayColor={'TRANSPARENT'}
                    onPress={() => setToolTipVisibility(true)}
                    onHover={(value: boolean) => {
                      setToolTipVisibility(value)
                    }}>
                    <Icon id={'INFO'} color={theme?.brandColor as ColorOptions} size={'LARGE'} />
                  </Box>
                </Box>
                <CVVToolTip visible={toolTipVisibility} />
              </Box>
            )}
            <Spacer direction={'vertical'} size={48} />
          </Box>
          <Box {...style.bsContainerMobileBottom}>
            <Box
              backgroundColor={theme?.brandColor as ColorOptions}
              disabled={!enalblePayButton()}
              onPress={makePayment}
              testID={'add-and-paySecureBtn'}
              width={'100%'}
              height={48}
              flexDirection={'row'}
              borderRadius={8}
              opacity={enalblePayButton() ? 1 : 0.5}
              underlayColor={theme?.brandColor as ColorOptions}
              ph={8}
              alignItems={'center'}
              justify={'center'}>
              {isLoading ? (
                <Loader testID="buttonLoader" color="WHITE" />
              ) : (
                <>
                  <Icon id={'LOCK'} size={20} color={theme?.headingText as ColorOptions} />
                  <Box ph={8}>
                    <Text color={theme?.headingText as ColorOptions} type={'bodySecondary14'}>
                      {btnTitle ? btnTitle : amount ? `Pay ₹ ${amount}` : 'Pay Securely'}
                    </Text>
                  </Box>
                </>
              )}
            </Box>
            {btnFooter && btnFooter}
          </Box>
        </>
      </ScrollView>
    </Box>
  )
}

export { CardComponent }
